
import offerOwnershipCost from "~/apollo/queries/ownershipCost";
import { mapGetters } from "vuex";
import TippyQuestion from "~/components/tippy/tippy-question";

export default {
  components: { TippyQuestion },
  props: ['offer'],
  data() {
    return {
      summ: 0,
      total: 0,
      all_data: [],
      sections: [],
      selectedPeriod: 'month',
      isLoading: false,
      colors: ['#005ff9', '#ed7b29', '#0dc268', '#ed2939'],
      cachedData: {
        year: {
          fetched: false,
          loading: false,
          error: null,
          items: null,
          summ: 0,
          total: 1,
          sections: [],
          all_data: []
        },
        month: {
          fetched: false,
          loading: false,
          error: null,
          items: null,
          summ: 0,
          total: 1,
          sections: [],
          all_data: []
        }
      }
    };
  },
  mounted() {
    this.loadDataForPeriod(this.selectedPeriod);
  },
  computed:{
    ...mapGetters({
      site_id: 'site_id',
      settings: 'settings/settings/settings'
    }),
    periodText() {
      return this.selectedPeriod === 'year' ? 'в год' : 'в месяц';
    },
    hasDataForCurrentPeriod() {
      const cache = this.cachedData[this.selectedPeriod];
      return cache && cache.fetched && !cache.error && cache.items && cache.items.length > 0;
    },
    errorForCurrentPeriod() {
        const cache = this.cachedData[this.selectedPeriod];
        return cache && cache.fetched && cache.error;
    }
  },
  methods: {
    toRubles(number) {
      if (number === null || typeof number === 'undefined') return '0 ₽';
      return (
        String(Math.round(number)).replace(
          /(\d)(?=(\d\d\d)+([^\d]|$))/g,
          '$1 '
        ) + ' ₽'
      );
    },
    precentage(value) {
      if (!this.summ || this.summ === 0) return 0;
      return Math.floor((+value / this.summ) * 100);
    },

    async loadDataForPeriod(period) {
      const cache = this.cachedData[period];

      if (cache.fetched && !cache.error) {
        this.updateDisplayFromCache(period);
        return;
      }
      if (cache.loading) {
        return;
      }

      this.isLoading = true;
      cache.loading = true;
      cache.error = null;

      try {
        const days = period === 'year' ? 365 : 30;
        const response = await this.$apollo.query({
          query: offerOwnershipCost,
          variables: {
            mark_slug: this.$route.params.mark,
            folder_slug: this.$route.params.model,
            external_id: Number(this.$route.params.car),
            site_id: this.site_id,
            day: days
          },
           fetchPolicy: 'network-only'
        });

        cache.items = response.data.offerOwnershipCost?.items || [];
        this.processAndCacheData(period);
        cache.fetched = true;

      } catch (error) {
        cache.error = error;
        cache.items = null;
        cache.fetched = true;
        this.clearDisplayData();
      } finally {
        cache.loading = false;
        this.isLoading = Object.values(this.cachedData).some(p => p.loading);
        if (this.selectedPeriod === period) {
             this.updateDisplayFromCache(period);
        }
      }
    },

    processAndCacheData(period) {
        const cache = this.cachedData[period];
        if (!cache.items) return;

        let currentSumm = 0;
        const newSections = [];
        const newAllData = [];
         const previousDisState = this.all_data.reduce((acc, item) => {
             if (item.label) {
                 acc[item.label] = item.dis || false;
             }
             return acc;
        }, {});


        cache.items.forEach((el, ind) => {
            const value = Number(el.value);
             if (!isNaN(value)) {
                const label = el.label;
                const text = label + ' <span>' + this.toRubles(value) + '</span>';
                const isDis = previousDisState[label + ' ' + this.toRubles(value)] || false;

                const dataItem = {
                    label: label + ' ' + this.toRubles(value),
                    text: text,
                    value: value,
                    originalLabel: label,
                    color: this.colors[ind % this.colors.length],
                    dis: isDis
                };

                newAllData.push(dataItem);

                if (!isDis) {
                    currentSumm += value;
                    newSections.push({
                       label: dataItem.label,
                       text: dataItem.text,
                       value: dataItem.value,
                       color: dataItem.color
                    });
                }
            } else {
              console.warn(`Invalid value received for ${el.label}:`, el.value);
            }
        });

        cache.summ = currentSumm;
        cache.total = currentSumm > 0 ? currentSumm : 1;
        cache.sections = newSections;
        cache.all_data = newAllData;

    },

    updateDisplayFromCache(period) {
      const cache = this.cachedData[period];
      if (cache && cache.fetched && !cache.error) {
        this.summ = cache.summ;
        this.total = cache.total;
        this.sections = cache.sections;
        this.all_data = JSON.parse(JSON.stringify(cache.all_data));
      } else {
         this.clearDisplayData();
      }
    },

    clearDisplayData() {
        this.summ = 0;
        this.total = 1;
        this.sections = [];
        this.all_data = [];
    },

    resetCache() {
        this.cachedData = {
            year: { fetched: false, loading: false, error: null, items: null, summ: 0, total: 1, sections: [], all_data: [] },
            month: { fetched: false, loading: false, error: null, items: null, summ: 0, total: 1, sections: [], all_data: [] }
        };
    },

    changePeriod(newPeriod) {
      if (this.selectedPeriod === newPeriod || this.isLoading) {
        return;
      }
      this.selectedPeriod = newPeriod;
      this.loadDataForPeriod(newPeriod);
      this.updateDisplayFromCache(newPeriod);
    },

    editSumm(clickedItem) {
        if (!clickedItem || !clickedItem.label) return;

        const currentPeriod = this.selectedPeriod;
        const cache = this.cachedData[currentPeriod];

        const itemIndex = this.all_data.findIndex(item => item.label === clickedItem.label);
        if (itemIndex === -1) return;

        const currentDisState = this.all_data[itemIndex].dis || false;
        const newDisState = !currentDisState;

        const visibleItemsCount = this.all_data.filter(item => !item.dis).length;
        if (newDisState === true && visibleItemsCount <= 1) {
            return;
        }

        this.$set(this.all_data[itemIndex], 'dis', newDisState);

        let newSumm = 0;
        const newSections = [];
        this.all_data.forEach(item => {
            if (!item.dis) {
                newSumm += item.value;
                newSections.push({
                    label: item.label,
                    text: item.text,
                    value: item.value,
                    color: item.color
                });
            }
        });
        this.summ = newSumm;
        this.total = newSumm > 0 ? newSumm : 1;
        this.sections = newSections;

    },
  },
  watch: {
    '$route.params': {
        handler() {
            this.resetCache();
            this.selectedPeriod = 'year';
            this.clearDisplayData();
            this.loadDataForPeriod('year');
        },
        deep: true,
    }
  }
};
